import { render, staticRenderFns } from "./CCPA.vue?vue&type=template&id=766d5b84"
import script from "./CCPA.vue?vue&type=script&lang=js"
export * from "./CCPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports